import { getDeviceInfo } from "./getDeviceInfo";
import { isNeoControlPanel } from "./brand-detection.helper";

export function getMobileOperatingSystem() {
  const deviceInfo = getDeviceInfo();
  return deviceInfo.os.name;
}

export const isIOSDevice = () => {
  const device = getMobileOperatingSystem();
  return ["ios", "macos"].includes(device.toLowerCase());
};

export const isAndroidDevice = () => {
  const device = getMobileOperatingSystem();
  return device.toLowerCase() === "android";
};

export const isMacDevice = () => {
  const device = getMobileOperatingSystem();
  // ua-parser-js reports macOS as "Mac OS" (with a space), so match the
  // "mac" substring rather than an exact string (covers "Mac OS",
  // "Mac OS X", "macOS").
  return device.toLowerCase().includes("mac");
};

export const _createUserAgentHeader = () => {
  const appVersion = process.env.VUE_APP_BUILD_VERSION;
  const { os, browser } = getDeviceInfo() || {};
  const locale = document.documentElement.getAttribute("lang");
  const client = "control_panel";
  const tp = isNeoControlPanel ? "neo" : "titan";

  return [
    `client=${client}`,
    `tp=${tp}`,
    `os=${os?.name}`,
    `os-version=${os?.version}`,
    `app-version=${appVersion}`,
    `locale=${locale}`,
    `browser-version=${browser?.version}`,
    `browser-name=${browser?.name}`,
  ].join(";");
};

export const getUserAgentHeader = (() => {
  const header = _createUserAgentHeader(); // Generate the header once
  return () => header; // Provide a function to access the cached header
})();
